module.exports = __webpack_public_path__ + "static/media/instagram_logo.17b6c6ea.svg";